import React, { useEffect } from "react";
import EmailIcon from "../../assets/images/email-icon.svg";
import "antd/dist/antd.css";
import "../../css/users.css";
import LeftSideNav from "../../components/LeftSideNav";
// import Verified from "../../assets/images/user_verified.svg";
import NoInterviews from "../../assets/images/no-interviews.svg";
import { useVerifyEmailMutation } from "../../store/appSlice";
import { Button } from "antd";
import { useNavigate, useParams } from "react-router-dom";

function UserVerified() {
  const navigate = useNavigate();
  const [verifyEmail] = useVerifyEmailMutation();
  const { email_token } = useParams();
  useEffect(() => {
    console.log({ email_token });
    const payload = {
      secretKey: email_token,
    };
    verifyEmail(payload)
      .unwrap()
      .then((incomingData) => {})
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const waitingSecView = () => (
    <div className="main-right-div">
      <div className="verify-form-div">
        <img alt="email icon" src={EmailIcon} className="email-icon" />
        <h2>Your email is verified</h2>
        <div className="verify-form-message">
          <h4>Now you can login to 01Hire and setup your profile.</h4>
        </div>
        <div
          style={{
            marginTop: "20px",
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => {
              navigate("/auth/login", { replace: true });
            }}
          >
            Go to login
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ height: "200px", width: "200px" }}>
        <img src={NoInterviews} alt="using-01hire" />
      </div>
      <div>{waitingSecView()}</div>
    </div>
  );
}

export default UserVerified;
